import { HTTPError } from 'ky'
import router from '#app/router'
import { doTgLogin, doWebLogin, getTgBotRole, keycloak } from '#shared/lib/auth'
import { combinePaths } from '#shared/lib/strings'

export default async function shouldBeLoggedIn() {
  if (keycloak.tokenParsed) {
    return
  }

  if (import.meta.env.PUBLIC_PLATFORM === 'telegram') {
    try {
      await doTgLogin()
    } catch (error) {
      if (error instanceof HTTPError) {
        const botRole = getTgBotRole()

        if (error.response.status === 404) {
          if (window.location.pathname !== combinePaths(router.basepath, `/${botRole}/tg-preregister`)) {
            router.navigate({ to: `/${botRole}/tg-preregister` })
          }
        }
      }
    }
  } else {
    await doWebLogin()
  }
}
